module.exports = __webpack_public_path__ + "img/lr-cb6-y1.0f99f1e9.gif";